import React from 'react';

const CompaniesPricingSection = () => (
    <section className="lp-pricing-sec">
        <div className="lp-eyebrow" data-lp-reveal>
            <span className="lp-badge lp-badge--up"><span />Pricing</span>
        </div>
        <h2 className="lp-h2" data-lp-reveal data-lp-delay="60" style={{ textAlign: 'center', margin: '0 auto 10px', maxWidth: 680 }}>Transparent. No hidden fees.</h2>
        <p data-lp-reveal style={{ textAlign: 'center', color: '#5B6472', fontSize: 17, margin: '0 auto 44px' }}>Less than a day of fractional CFO time.</p>
        <div className="lp-pricing-grid lp-pricing-grid--4">
            <div className="lp-price" data-lp-reveal>
                <div className="lbl">Free</div>
                <div className="amt">£0</div>
                <p>Readiness checklists, KPI suggestions, InvestorMatch fit score.</p>
            </div>
            <div className="lp-price lp-price--lite" data-lp-reveal data-lp-delay="80">
                <div className="lbl">Lite</div>
                <div className="amt blue">£100<span className="per"> / yr</span></div>
                <p>Business Audit + Data Repository (20 sections each).</p>
            </div>
            <div className="lp-price lp-price--pro" data-lp-reveal data-lp-delay="160">
                <div className="lp-price-badge">Popular</div>
                <div className="lbl">Pro</div>
                <div className="amt white">£1,000<span className="per"> / yr</span></div>
                <p>Full platform — all modules, AI reports, certifications, InvestorMatch introductions.</p>
            </div>
            <div className="lp-price lp-price--dark" data-lp-reveal data-lp-delay="240">
                <div className="lbl">Portfolio Pro</div>
                <div className="amt">£800<span className="per"> / yr</span></div>
                <p>All Pro features — 20% off via a Diligentsia partner introduction.</p>
            </div>
        </div>
        <p className="lp-price-note" data-lp-reveal>All prices exclude VAT. Portfolio Pro available via partner introduction.</p>
    </section>
);

export default CompaniesPricingSection;
